/**
 * Saga
 */
import { call, put, takeEvery } from 'redux-saga/effects';

/**
 * Library
 */
import { AxiosResponse } from 'axios';

/**
 * Actions
 */
import { RequestCheckObjectAction } from 'redux/actions/aws/type';
import { requestCheckObjectFailure, requestCheckObjectSuccess } from 'redux/actions/aws/actions';
import { throwError } from 'redux/actions/actions';
import { REQUEST_CHECK_OBJECT } from 'redux/actions/aws/types';

/**
 * Framework
 */
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import { API } from 'commons/constants/KeyFlowAPI';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';

function* requestCheckObject(action: RequestCheckObjectAction) {
  try {
    const { param } = action.payload;

    console.log(param);

    const awsResponse: AxiosResponse = yield call(getAPI, API.AWS, param);

    const awsKeyFlowResponse = new KeyFlowResponse(awsResponse.data);

    const isExist = awsKeyFlowResponse.getResult()?.[0]?.EXIST ?? false;

    console.log('isExist: ', isExist);

    yield put(requestCheckObjectSuccess({
      exist: isExist,
    }))

  } catch(error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestCheckObjectFailure());
  }
}

export function* watchAwsSaga() {
  yield takeEvery(REQUEST_CHECK_OBJECT, requestCheckObject);
}
